var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91747 2.01318C9.39859 1.17985 10.6014 1.17985 11.0825 2.01318L18.8768 15.5132C19.3579 16.3465 18.7565 17.3882 17.7942 17.3882H2.20577C1.24352 17.3882 0.642114 16.3465 1.12324 15.5132L8.91747 2.01318Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.13818V10.6382",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.8381V14.1381",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgIconWarning;